// extracted by mini-css-extract-plugin
module.exports = {"LinkToTop":"JIcon_LinkToTop__2oHOv"};